import { Component, Input, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { Delivery } from 'app/core/models';
import * as fromRoot from 'app/core/store';
import { DownloadBtnService } from './download-btn.service';

@Component({
  standalone: false,
  selector: 'pptl-download-btn',
  templateUrl: 'download-btn.component.html',
  styleUrls: ['download-btn.component.scss'],
})
export class DownloadBtnComponent implements OnDestroy {
  @Input() delivery: Delivery;
  @Input() downloadConf: {
    isOffline: boolean;
    wifiOnly: boolean;
    cacheEnabled: boolean;
    networkType: string;
  };

  private destroy$: Subject<boolean> = new Subject();

  constructor(
    private store: Store<fromRoot.State>,
    public modalController: ModalController,
    private downBtnService: DownloadBtnService,
  ) {}

  toggleDownload($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();

    if (this.isDeliveryDownloaded) {
      this.downBtnService.showRemoveDownloadedModal(this.delivery);
    } else if (this.isDeliveryDownloading) {
      this.downBtnService.showCancelDownloadModal(this.delivery);
    } else {
      this.startDownloading();
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  get isDeliveryDownloading(): boolean {
    return this.delivery.offlineStatus === 'downloading';
  }

  get isDeliveryDownloaded(): boolean {
    return this.delivery.offlineStatus === 'downloaded';
  }

  get isButtonVisible(): boolean {
    return this.delivery.deliveryHasOfflineAssets;
  }

  get isWifiError(): boolean {
    return this.downloadConf.wifiOnly && this.downloadConf.networkType !== 'wifi';
  }

  get isCacheEnableErorr(): boolean {
    return !this.downloadConf.cacheEnabled;
  }

  private startDownloading(): void {
    if (this.isCacheEnableErorr) {
      this.downBtnService.showLimitDownloadWindow(this.delivery);
    } else if (this.isWifiError) {
      this.downBtnService.showWifiWarning(this.delivery);
    } else {
      const delivery = { ...this.delivery };
      this.store.dispatch(fromRoot.saveOfflineDelivery({ delivery: { ...delivery } }));
    }
  }
}
